import React from "react";
import Skeleton from "../common/Skeleton";

const StatCard = ({ title, value, subtitle, color, loading }) => {
    return (
        <div className="stat-card">
            {loading ? (
                <>
                    <Skeleton width="50%" height={16}/>
                    <div style={{ height: 10 }}/>
                    <Skeleton width="40%" height={34}/>
                    <div style={{ height: 8 }}/>
                    <Skeleton width="70%" height={12}/>
                </>
            ) : (
                <>
                    <div className="stat-title">{title}</div>
                    <div className="stat-value" style={{ color }}>
                        {value}
                    </div>
                    {subtitle && <div className="stat-sub">{subtitle}</div>}
                </>
            )}
        </div>
    );
};

export default StatCard;
